module.exports = __webpack_public_path__ + "img/ic_appointment.e44f95b1.png";